export default __webpack_public_path__ + "static/media/xcx.2dc51131.png";